import { Grid } from '@mui/material';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import WorkQueues from 'enums/workQueue.enum';
import { getInClaimEligibilityRequestsByPage } from 'store/thunks/workQueueThunks';
import { useWorkQueueTabSwitch } from '../contexts/WorkQueueTabSwitchContext';

import InClaimEligibilityTable from './InClaimEligibilityTable';
import InClaimEligibilityFilterButton from './InClaimEligibilityFilterButton';
import InClaimEligibilityFilterStatusBar from './InClaimEligibilityFilterStatusBar';

const InClaimEligibility = () => {
  const dispatch = useDispatch();
  const preset = useSelector(({ workQueue }) => workQueue.preset);
  const { currentPage } = useSelector(
    ({ workQueue }) => workQueue.inClaimEligibility,
    shallowEqual
  );
  const { isTabSwitch } = useWorkQueueTabSwitch();

  useEffect(() => {
    if (isTabSwitch(WorkQueues.IN_CLAIM_ELIGIBILITY)) {
      dispatch(getInClaimEligibilityRequestsByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, isTabSwitch]);

  if (preset !== WorkQueues.IN_CLAIM_ELIGIBILITY) return null;

  return (
    <Grid container sx={{ py: 2 }}>
      <Grid item sx={{ minHeight: 40, flexGrow: 1 }} alignItems='center'>
        <InClaimEligibilityFilterStatusBar />
      </Grid>
      <Grid item>
        <InClaimEligibilityFilterButton />
      </Grid>
      <InClaimEligibilityTable />
    </Grid>
  );
};

export default InClaimEligibility;
